import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { Loading } from '@revelio/core';

import { environment } from '../../environments/environment';
import { ImpersonationLinkGate } from '../adminRewrite/impersonation/ImpersonationLinkGate';
import Tutorial from '../tutorial/Tutorial';
import { AuthGate } from './AuthGate';
import styles from './private-route.module.css';

export const PrivateRoute = ({ sessionToken }: { sessionToken?: string }) => {
  const [isRequestingSessionCookie, setIsRequestingSessionCookie] = useState(
    !!sessionToken
  );

  useEffect(() => {
    if (!isRequestingSessionCookie) return;

    let cancelled = false;
    const fetchSessionCookie = async () => {
      try {
        const response = await fetch(
          `${environment.DASH_META_API}/api/session-auth/get-session`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ session_token: sessionToken }),
            credentials: 'include',
          }
        );
        if (!response.ok) {
          console.error(`Session token handoff failed: ${response.status}`);
        }
      } catch (error) {
        // Network/CORS failure: fall through to AuthGate, which re-validates.
        console.error('Session token handoff request failed', error);
      } finally {
        if (!cancelled) setIsRequestingSessionCookie(false);
      }
    };
    fetchSessionCookie();

    return () => {
      cancelled = true;
    };
  }, [sessionToken, isRequestingSessionCookie]);

  if (isRequestingSessionCookie) {
    return (
      <div className={styles.loadingState}>
        <Loading />
      </div>
    );
  }

  return (
    <AuthGate>
      <ImpersonationLinkGate>
        {/* Onboarding is the auto-started tour. `Tutorial` stays mounted, but
            its only entry point left is the `?vtid=` deep link. */}
        <Tutorial />
        <Outlet />
      </ImpersonationLinkGate>
    </AuthGate>
  );
};
